import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomeContactForm from "@/components/HomeContactForm";
import useDocumentTitle from "@/lib/useDocumentTitle";
import { Card, CardContent } from "@/components/ui/card";

export default function Contact() {
  useDocumentTitle(
    "Contact Azure Gypsy Guild — Speak with a Trustee | Foreclosure Help",
    "Submit the Azure Gypsy Guild contact form for counterclaim mortgage relief, foreclosure mediation, and trustee services. Submissions route directly to the trustee admin portal — one business day response, urgent triage for sheriff sales.",
  );

  return (
    <div className="min-h-screen bg-paper" data-testid="contact-page">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 py-16">
        <div className="text-center">
          <span className="uppercase text-xs tracking-[0.25em] text-[color:var(--fire-red)]">Contact</span>
          <h1 className="font-serif text-4xl sm:text-6xl mt-3 leading-none">Speak with a trustee</h1>
          <p className="text-[color:var(--text-secondary)] mt-4 text-lg">
            Submissions route directly to the trustee admin portal. One business day response;
            sheriff-sale and court-deadline cases are triaged urgently.
          </p>
        </div>

        <Card className="border-black/5 mt-10">
          <CardContent className="p-6 sm:p-8">
            <HomeContactForm />
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
